import { render } from "./EscritorioSolicitudes.vue?vue&type=template&id=4c982852"
import script from "./EscritorioSolicitudes.vue?vue&type=script&lang=js"
export * from "./EscritorioSolicitudes.vue?vue&type=script&lang=js"

import "./EscritorioSolicitudes.vue?vue&type=style&index=0&id=4c982852&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__